import React, {Component} from 'react';
import Modal from 'components/Modal';
import LoginForm from 'components/auth/LoginForm';
import './index.scss';
import RegisterForm from 'components/auth/RegisterForm';

interface LoginModalState {
  loggingIn: boolean
}

interface LoginModalProps {
  open: boolean;
  onLoggedIn: ()=>void;
  onCancelled?: ()=>void;
}

export default class LoginModal extends Component<LoginModalProps, LoginModalState> {
  state = {
    loggingIn: true
  };

  onClosing = () => {
    if(this.props.onCancelled) {
      this.props.onCancelled();
    }
  };

  onLogin = () => {
    this.setState({loggingIn: true});
  };

  onRegister = () => {
    this.setState({loggingIn: false});
  };

  render() {
    return <Modal className="login-modal" open={this.props.open} onClosing={this.onClosing}>
      { this.state.loggingIn
        ? <LoginForm onLoggedIn={this.props.onLoggedIn} onRegister={this.onRegister}/>
        : <RegisterForm onRegistered={this.props.onLoggedIn} onLogin={this.onLogin}/>
      }
    </Modal>;
  }
}